<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert, Container } from '@Shelly/shelly-design-system/index';
	import ThumbLayerChart from '../Chart/LayerChart/ThumbLayerChart.svelte';
	import type { ChartConfigInterface } from 'src/types/Chart';
	import DistanceOnboardingModal from '../Modals/Onboarding/Distance/DistanceOnboardingModal.svelte';
	import LiquidSolidType from './LiquidSolidType.svelte';
	import OccupancyType from './OccupancyType.svelte';
	import GarageShutterType from './GarageShutterType.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let device;
	export let deviceChartsConfig: ChartConfigInterface[];
	export let handleOnClickThumbChart: (e: CustomEvent | Event) => void;

	let showModal = false;
</script>

<div
	class={classMap({
		'mb-s main-tab-container': !$showNewLayout,
	})}
>
	{#if !device?.onboarded}
		<div class="main-tab-first-inner-container">
			<Alert
				isHeadingBold
				heading={$format('alert_heading_distance_configuration', {
					default: 'Configuration needed',
				})}
				message={$format('alert_message_distance_configuration', {
					default: "This device isn't set up yet. Start the setup wizard to configure it now.",
				})}
				cta={{
					title: $format('alert_cta_start_setup', {
						default: 'Start configuration',
					}),
					enableAlertClick: false,
				}}
				on:cta_click={() => {
					showModal = true;
				}}
			/>
		</div>
	{/if}

	{#if device?.modeType === 'garage'}
		<GarageShutterType {device} hasMb />
	{:else if device?.modeType === 'occupancy'}
		<OccupancyType {device} hasMb />
	{:else}
		<LiquidSolidType {device} hasMb />
		<Container padding="xs">
			<div class="content-background light">
				<ThumbLayerChart
					{device}
					{deviceChartsConfig}
					legacyStyle
					on:click={handleOnClickThumbChart}
				/>
			</div>
		</Container>
	{/if}
</div>

<DistanceOnboardingModal {device} bind:showModal />

<style>
	.main-tab-container {
		background-color: #0e0f10;
		border-radius: 18px;
		padding: 8px;
	}

	.main-tab-first-inner-container {
		margin-bottom: 12px;
	}
</style>
